import update from 'immutability-helper';

/**
 * compare values and return true if they are either equal or both missing
 */
export const equalOrBothMissing = (a, b) => a === b || (!a && !b);

/** merges two lists of services without producing duplicates */
export const mergeServices = (services, newServices) =>
  newServices.reduce((result, newItem) => {
    const itemIndex = result.findIndex((item) => `${item.id}` === `${newItem.id}`);

    /** if service exists, increment its quantity */
    if (itemIndex !== -1) {
      return update(result, {
        [itemIndex]: {
          quantity: { $apply: (value) => value + newItem.quantity },
        },
      });
    }

    /** otherwise add it before other services */
    return [newItem, ...result];
  }, services);

export const getBasketCount = (items) => {
  let countCart = 0;
  items.forEach((itm) => {
    countCart += 1;
    (itm?.children || []).forEach((child) => {
      if (child.itemType === 'service' || child.itemType === 'ctn') {
        countCart += 1;
      }
    });
  });
  return countCart;
};
